<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-if="!hasIcon" :color="color" dark plain v-bind="attrs" v-on="on">
        {{ label }}
      </v-btn>
      <v-btn v-if="hasIcon" icon v-bind="attrs" v-on="on">
        <v-icon :color="color" :title="label">{{ icon }}</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>
      <v-card-text>{{ text }}</v-card-text>
      <v-card-actions>
        <v-btn color="error" plain @click="onCancel">
          {{ cancelText }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn tile large color="primary" @click="onConfirm">
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    color: { type: String, default: 'error' },
    icon: { type: String, required: false },
    label: { type: String, default: 'delete' },
    title: { type: String, default: 'Confirm' },
    text: { type: String, default: 'Are you sure?' },
    confirmText: { type: String, default: 'Yes, Delete' },
    cancelText: { type: String, default: 'Cancel' }
  },
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    hasIcon() {
      return this.icon !== undefined
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirm')
      this.dialog = false
    },
    onCancel() {
      this.$emit('cancel')
      this.dialog = false
    }
  }
}
</script>

<style></style>
